// Ejecuta la funcion al momento de ocultar el loader o el agegate
export const pageLoaded = (callback: () => void) => {
    
    if (!localStorage.hasOwnProperty('ageGateValidate')) {
        window.addEventListener('onHideAgegate', () => {
            callback();
        })
    }
    else {
        window.addEventListener('onHideLoader', () => {
            callback();
        })
    }
}